import { render, staticRenderFns } from "./dataAnalyst.vue?vue&type=template&id=1e147119&scoped=true&"
import script from "./dataAnalyst.vue?vue&type=script&lang=js&"
export * from "./dataAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./dataAnalyst.vue?vue&type=style&index=0&id=1e147119&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e147119",
  null
  
)

export default component.exports